class AccountForms extends HTMLElement {
  constructor () {
    super()
    this.url = new URL(window.location.href)
    this.hash = window.location.hash
    this.queriedTab = this.url.searchParams.get('tab')
    this.tabs = document.querySelectorAll('[data-tab]')
  }

  connectedCallback () {
    if (window.matchMedia('max-width: 768px')) {
      if (this.queriedTab === null && this.hash !== '#recover') {
        setUrlParams('tab', 'login', this.url)
      }
      if (this.queriedTab === 'register') {
        document.querySelector('[data-tab="register"]').click()
      }
      this.tabs.forEach((tabName) => {
        tabName.addEventListener('click', () => {
          setUrlParams('tab', tabName.dataset.tab, this.url)
        })
      })
    }
    function setUrlParams (param, tabValue, thisUrl) {
      thisUrl.searchParams.set(param, tabValue)
      history.pushState(null, document.title, thisUrl.toString())
    }
  }
}

if (!customElements.get('account-forms')) {
  customElements.define('account-forms', AccountForms)
}
